import axios from "axios";
import { getToken } from "../../Utils/UpdateUsersState";

const truncateFileName = (name, maxLength = 80) => {
  if (!name || name.length <= maxLength) return name;

  const dotIndex = name.lastIndexOf(".");
  const ext = dotIndex !== -1 ? name.slice(dotIndex) : "";
  const base = dotIndex !== -1 ? name.slice(0, dotIndex) : name;

  return `${base.slice(0, maxLength - ext.length)}${ext}`;
};

const getCustomerData = async () => {
  try {
    const token = getToken();

    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}user_panel/customers/`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("Customer data fetch error:", error);
    throw error;
  }
};

const getCustomerDataById = async (id) => {
  try {
    const token = getToken();

    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}user_panel/customers/?customer_id=${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("Customer data fetch error:", error);
    throw error;
  }
};

const deleteCustomer = async (customer_id) => {
  try {
    const res = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}user_panel/customers/`,
      {
        data: { customer_id },
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      },
    );
    return res;
  } catch (e) {
    console.error("Error deleting customer", e);
    return e;
  }
};
const getCustomerbyCompanyId = async (company_id) => {
  try {
    const token = getToken();

    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}user_panel/customers/?company_id=${company_id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("Coustomer data fetch error:", error);
    throw error;
  }
};

const editCustomer = async ({
  customer_id,
  customer_name,
  email,
  api_key,
  domain,
  secret_pin,
  customer_phone,
  emergency_contact_person,
  emergency_contact_phone,
  vehicle_ids = [],
  profile_picture,
  recovery_company_id,
}) => {
  try {
    const formData = new FormData();

    formData.append("customer_id", Number(customer_id));
    formData.append("customer_name", customer_name);
    formData.append("email", email);
    formData.append("api_key", api_key);
    formData.append("domain", domain);
    formData.append("secret_pin", secret_pin);
    formData.append(
      "customer_phone",
      customer_phone?.startsWith("+") ? customer_phone : `+${customer_phone}`,
    );

    formData.append("emergency_contact_person", emergency_contact_person || "");
    formData.append("recovery_company_id", recovery_company_id || "");
    formData.append(
      "emergency_contact_phone",
      emergency_contact_phone?.startsWith("+")
        ? emergency_contact_phone
        : `+${emergency_contact_phone}`,
    );

    vehicle_ids.forEach((id) => {
      formData.append("vehicle_ids", Number(id));
    });

    if (profile_picture) {
      formData.append(
        "customer_profile_picture",
        profile_picture,
        truncateFileName(profile_picture.name),
      );
    }

    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}user_panel/customers/`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": "multipart/form-data",
        },
      },
    );

    return res;
  } catch (e) {
    console.error(e.response?.data || e);
    throw e;
  }
};

const createCustomer = async (formData) => {
  const token = getToken();

  const response = await axios.post(
    `${process.env.REACT_APP_BACKEND_URL}user_panel/customers/`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    },
  );

  return response.data;
};

export {
  getCustomerData,
  getCustomerDataById,
  deleteCustomer,
  editCustomer,
  truncateFileName,
  getCustomerbyCompanyId,
  createCustomer,
};
